var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"account-activator",on:{"click":function($event){return _vm.setAccountSidebarExpanded(true)}}},[_c('div',{staticClass:"d-none d-md-block"},[_vm._v(" "+_vm._s(_vm.currentUser.username)+" ")]),_c('v-icon',{staticClass:"pl-3"},[_vm._v("mdi-account")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }